import { render, staticRenderFns } from "./ResultsComponent.vue?vue&type=template&id=473f43f2&scoped=true"
import script from "./ResultsComponent.vue?vue&type=script&lang=js"
export * from "./ResultsComponent.vue?vue&type=script&lang=js"
import style0 from "./ResultsComponent.vue?vue&type=style&index=0&id=473f43f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f43f2",
  null
  
)

export default component.exports